import CheckTag from './check-tag.vue';
import CheckTagGroup from './check-tag-group.vue';

CheckTag.Group = CheckTagGroup;
export default CheckTag;